import type { EmptyPageProps, PageHeroSection, PageProps, PageSection } from './components/page';
import type { UniclientPageFrame } from './frame';
import type { UniclientStepPresentation } from './step';

export type PagePresentationProps<T extends string> = Omit<UniclientPageFrame, 'type'> &
  Omit<UniclientStepPresentation<T>, 'component' | 'frame' | 'type'> &
  (EmptyPageProps<T> | PageProps<T>);

export function page<TComponentAttributes extends string>(
  props: PagePresentationProps<TComponentAttributes>,
): UniclientStepPresentation<TComponentAttributes> {
  return {
    frame: {
      type: 'page',
      title: props.title,
      progress: props.progress,
      summary: props.summary,
      header: props.header ?? {},
      lockHistory: props.lockHistory ?? true,
      toast: props.toast,
      action: props.action,
      eventPrefix: props.eventPrefix,
      coInsurance: props.coInsuranceFooter,
    },
    dialogs: props.dialogs,
    component: {
      type: 'page',
      sections: props.sections,
      hero: props.hero,
    },
  } as UniclientStepPresentation<TComponentAttributes>;
}

export function pageSection<TComponentAttributes extends string>(
  props: PageSection<TComponentAttributes>,
): PageSection<TComponentAttributes> {
  return props;
}

export function hero<TComponentAttributes extends string>(
  props: PageHeroSection<TComponentAttributes>,
): PageHeroSection<TComponentAttributes> {
  return props;
}
